import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Previous / "N of M" / next for the Next Best Action card (CT-5713). No
 * wrap-around: the ends disable their button. The counter is a polite live
 * region, so moving announces where the user is.
 */
const NextBestActionCarouselNav = memo(function NextBestActionCarouselNav({
  index,
  total,
  previousTitle,
  nextTitle,
  onPrevious,
  onNext,
}) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div className="flex shrink-0 items-center gap-1">
      <Button
        variant="ghost"
        size="sm"
        leftIcon={ChevronLeft}
        onClick={onPrevious}
        disabled={index === 0}
        aria-label={previousTitle ? t('profile.nba.previousNamed', { title: previousTitle }) : t('profile.nba.previous')}
      />
      <span aria-live="polite" className="min-w-[3rem] text-center text-xs text-content-secondary">
        {t('profile.nba.position', { index: index + 1, total })}
      </span>
      <Button
        variant="ghost"
        size="sm"
        leftIcon={ChevronRight}
        onClick={onNext}
        disabled={index >= total - 1}
        aria-label={nextTitle ? t('profile.nba.nextNamed', { title: nextTitle }) : t('profile.nba.next')}
      />
    </div>
  );
});

export default NextBestActionCarouselNav;
